'use strict';

import Api from '../modules/Elements/Api';

export default function ( Vue, options ) {
  Vue.prototype.$api = new Api(options);
}
